import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createNews, createTip, createVideo, deleteNews, deleteTip, deleteVideo, getNewsById, getNewsList, getTipById, getTipsList, getVideoById, getVideoList, updateNews, updateTip, updateVideo } from '../api/knowledgeBoard';

// Tips Hooks

export const useCreateTip = () => {
    return useMutation({
        mutationKey: ['createTip'],
        mutationFn: (data) => createTip(data),
    })
}

export const useGetTipsList = () => {
    return useQuery({
        queryKey: ['getTipsList'],
        queryFn: () => getTipsList(),
    });
}

export const useGetTipById = (id) => {
    return useQuery({
        queryKey: ['getTipById', id],
        queryFn: () => getTipById(id),
        enabled: !!id,
    });
}

export const useUpdateTip = () => {
    return useMutation({
        mutationKey: ['updateTip'],
        mutationFn: (data) => updateTip(data)
    });
}

export const useDeleteTip = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['deleteTip'],
        mutationFn: (id) => deleteTip(id),
        onSuccess: () => queryClient.invalidateQueries(['getTipsList']),
    });
}

// News Hooks

export const useCreateNews = () => {
    return useMutation({
        mutationKey: ['createNews'],
        mutationFn: (data) => createNews(data),
    })
}

export const useGetNewsList = () => {
    return useQuery({
        queryKey: ['getNewsList'],
        queryFn: () => getNewsList(),
    });
}

export const useGetNewsById = (id) => {
    return useQuery({
        queryKey: ['getNewsById', id],
        queryFn: () => getNewsById(id),
        enabled: !!id,
    });
}

export const useUpdateNews = () => {
    return useMutation({
        mutationKey: ['updateNews'],
        mutationFn: (data) => updateNews(data)
    });
}

export const useDeleteNews = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['deleteNews'],
        mutationFn: (id) => deleteNews(id),
        onSuccess: () => queryClient.invalidateQueries(['getNewsList']),
    });
}
// Videos Hooks

export const useCreateVideo = () => {
    return useMutation({
        mutationKey: ['createVideo'],
        mutationFn: (data) => createVideo(data),
    })
}

export const useGetVideoList = () => {
    return useQuery({
        queryKey: ['getVideoList'],
        queryFn: () => getVideoList(),
    });
}

export const useGetVideoById = (id) => {
    return useQuery({
        queryKey: ['getVideoById', id],
        queryFn: () => getVideoById(id),
        enabled: !!id,
    });
}

export const useUpdateVideo = () => {
    return useMutation({
        mutationKey: ['updateVideo'],
        mutationFn: (data) => updateVideo(data)
    });
}

export const useDeleteVideo = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['deleteVideo'],
        mutationFn: (id) => deleteVideo(id),
        onSuccess: () => queryClient.invalidateQueries(['getVideoList']),
    });
}

